<template>
  <div class="doc-section">
    <div class="section-header">
      <span class="material-icons-sharp section-icon">rule</span>
      <h2>Pertes &amp; Manquants</h2>
    </div>

    <p class="section-intro">
      Ce module (réservé à l'administrateur) affiche les déclarations d'inventaire (manquants et excédents).
      L'administrateur valide l'ajustement du stock ou rejette la déclaration pour enquête.
    </p>

    <!-- ===== TRAITER UN ÉCART ===== -->
    <h3 class="sub-title">Traiter une déclaration d'inventaire</h3>
    <p class="section-text">
      Chaque déclaration d'écart soumise par un magasinier apparaît dans ce module
      avec les détails suivants (tous non modifiables) :
    </p>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr><th>Information</th><th>Description</th></tr>
        </thead>
        <tbody>
          <tr><td><strong>Produit</strong></td><td>Le produit concerné.</td></tr>
          <tr><td><strong>Quantité système</strong></td><td>Quantité dans le stock informatique.</td></tr>
          <tr><td><strong>Type de déficit</strong></td><td>Manquant ou Excédent.</td></tr>
          <tr><td><strong>Quantité déclarée</strong></td><td>Différence constatée.</td></tr>
          <tr><td><strong>Fichier preuve</strong></td><td>Justificatif (téléchargeable).</td></tr>
          <tr><td><strong>Observation</strong></td><td>Explication du magasinier.</td></tr>
        </tbody>
      </table>
    </div>

    <h4 class="sub-title">Procédure</h4>
    <div class="steps">
      <div class="step-item">
        <div class="step-num">1</div>
        <p>Ouvrez le module <strong>Pertes &amp; Manquants</strong> depuis le menu latéral.</p>
      </div>
      <div class="step-item">
        <div class="step-num">2</div>
        <p>Cliquez sur une déclaration dans le tableau pour voir le détail.</p>
      </div>
      <div class="step-item">
        <div class="step-num">3</div>
        <p>Examinez les informations et le fichier preuve.</p>
      </div>
      <div class="step-item">
        <div class="step-num">4</div>
        <p><strong>Pour valider l'ajustement :</strong> Cliquez sur <span class="btn-ref">Accepter le retour en stock</span>. Le stock est ajusté selon l'écart déclaré.</p>
      </div>
      <div class="step-item">
        <div class="step-num">5</div>
        <p><strong>Pour refuser :</strong> Cliquez sur <span class="btn-ref">Rejeter le retour en stock</span>. La déclaration est rejetée et le stock reste inchangé.</p>
      </div>
    </div>

    <div class="info-card warning">
      <div class="card-title">
        <span class="material-icons-sharp" style="font-size:16px;color:#ff9800">warning</span>
        Attention
      </div>
      <p>
        Accepter un manquant diminuera le stock système pour correspondre au stock réel.
        Accepter un excédent augmentera le stock système. Vérifiez soigneusement avant de valider.
      </p>
    </div>
  </div>
</template>
<script>
export default { name: "DocPertes" };
</script>
